<template>
  <div>
    <h1>Upload Value List</h1>
    <!-- Add your form or content here -->
  </div>
</template>

<script>
export default {
  name: "CreateValueList",
  data() {
    return {
      // Define your data properties
    };
  },
  methods: {
    // Define your methods
  },
};
</script>

<style scoped>
/* Optional: Add your styles here */
</style>
